import Ticket from "./Ticket";

function TicketList({ ticketList = [], onUpdate }) {
    return (
        <div className="container">
            <div className="row">
                {ticketList.map((ticket) => (
                    <Ticket key={ticket.id} ticket={ticket} onUpdate={onUpdate} />
                ))}
            </div>
        </div>
    );
}

export default TicketList;
